import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de confirmação de processo em pauta/sessão.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO = {
    CONFIRMADO     : { id: 'CONFIRMADO',     descricao: 'Confirmado'     },
    NAO_CONFIRMADO : { id: 'NAO_CONFIRMADO', descricao: 'Não confirmado' }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum.
 * @readonly
 */
export default class SituacaoConfirmacaoProcessoPautaSessao {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_VOTO =
        'Não foi possível identificar a situação da confirmação do processo em pauta/sessão.';

    static getDescricao(id) {
        return SituacaoConfirmacaoProcessoPautaSessao.situacaoBase.getDescricao(id);
    }
}
